import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from '../HtmlContent';
import NavButton from '../../elements/NavButton';

export default class Answer extends React.Component {
  constructor(props) {
    super(props);

    this.handleModalClose = this.handleModalClose.bind(this);
  }

  validateAnswer = (event) => {
    const { nextStepHandler } = this.props;
    nextStepHandler(event);
  };

  handleModalClose = () => {
    const { closeHandler } = this.props;

    closeHandler();
  };

  render() {
    const {
      contentCorrect,
      contentWrong,
      givenAnswer,
      nextStep,
      nextStepHandler,
      closeHandler,
      previousStepHandler,
    } = this.props;
    const {
      AdventCount: {
        translations: {
          common: {
            close,
            next,
            back,
          },
        },
      },
    } = window;

    let content = '';
    let buttonLabel = '';
    let buttonFunc = '';
    if ( givenAnswer ) {
      content = contentCorrect;
      buttonLabel = close;
      buttonFunc = closeHandler;
    } else {
      content = contentWrong;
      buttonLabel = back;
      buttonFunc = previousStepHandler;
    }

    return (
      <div className="adventcount-modal">
        <HtmlContent content={content} />
        <div className="adventcount-button-row">
            <NavButton
              toStep=""
              btnLabel={buttonLabel}
              direction="close"
              clickHandler={buttonFunc}
            />
          
            <NavButton
              toStep={nextStep}
              btnLabel={next}
              direction="next"
              clickHandler={nextStepHandler}
            />
          
        </div>
      </div>
    );
  }
}

Answer.propTypes = {
  contentCorrect: PropTypes.string.isRequired,
  contentWrong: PropTypes.string.isRequired,
  givenAnswer: PropTypes.bool.isRequired,
  nextStep: PropTypes.string.isRequired,
  nextStepHandler: PropTypes.func.isRequired,
  previousStepHandler: PropTypes.func.isRequired,
  closeHandler: PropTypes.func.isRequired,
};
